/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Signer,
  utils,
  BigNumberish,
  Contract,
  ContractFactory,
  Overrides,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PalmBridge, PalmBridgeInterface } from "../PalmBridge";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint8",
        name: "chainID",
        type: "uint8",
      },
      {
        internalType: "address[]",
        name: "initialRelayers",
        type: "address[]",
      },
      {
        internalType: "uint256",
        name: "initialRelayerThreshold",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "expiry",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint8",
        name: "destinationChainID",
        type: "uint8",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "uint64",
        name: "depositNonce",
        type: "uint64",
      },
    ],
    name: "Deposit",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        indexed: false,
        internalType: "string",
        name: "reason",
        type: "string",
      },
    ],
    name: "NotToppedUp",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint8",
        name: "originChainID",
        type: "uint8",
      },
      {
        indexed: true,
        internalType: "uint64",
        name: "depositNonce",
        type: "uint64",
      },
      {
        indexed: true,
        internalType: "enum Bridge.ProposalStatus",
        name: "status",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "dataHash",
        type: "bytes32",
      },
    ],
    name: "ProposalEvent",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint8",
        name: "originChainID",
        type: "uint8",
      },
      {
        indexed: true,
        internalType: "uint64",
        name: "depositNonce",
        type: "uint64",
      },
      {
        indexed: true,
        internalType: "enum Bridge.ProposalStatus",
        name: "status",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
    ],
    name: "ProposalVote",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "relayer",
        type: "address",
      },
    ],
    name: "RelayerAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "relayer",
        type: "address",
      },
    ],
    name: "RelayerRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "newThreshold",
        type: "uint256",
      },
    ],
    name: "RelayerThresholdChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "RELAYER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "_chainID",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    name: "_depositCounts",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64",
      },
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    name: "_depositRecords",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "_expiry",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "_fee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "uint72",
        name: "",
        type: "uint72",
      },
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "_hasVotedOnProposal",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "uint72",
        name: "",
        type: "uint72",
      },
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "_proposals",
    outputs: [
      {
        internalType: "bytes32",
        name: "_resourceID",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "_dataHash",
        type: "bytes32",
      },
      {
        internalType: "enum Bridge.ProposalStatus",
        name: "_status",
        type: "uint8",
      },
      {
        internalType: "uint256",
        name: "_proposedBlock",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "_relayerThreshold",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "_resourceIDToHandlerAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "_totalProposals",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "_totalRelayers",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "relayerAddress",
        type: "address",
      },
    ],
    name: "adminAddRelayer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newFee",
        type: "uint256",
      },
    ],
    name: "adminChangeFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newThreshold",
        type: "uint256",
      },
    ],
    name: "adminChangeRelayerThreshold",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "adminPauseTransfers",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "relayerAddress",
        type: "address",
      },
    ],
    name: "adminRemoveRelayer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "handlerAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
    ],
    name: "adminSetBurnable",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "handlerAddress",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "contractAddress",
        type: "address",
      },
      {
        internalType: "bytes4",
        name: "depositFunctionSig",
        type: "bytes4",
      },
      {
        internalType: "bytes4",
        name: "executeFunctionSig",
        type: "bytes4",
      },
    ],
    name: "adminSetGenericResource",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "handlerAddress",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
    ],
    name: "adminSetResource",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "adminUnpauseTransfers",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "handlerAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amountOrTokenID",
        type: "uint256",
      },
    ],
    name: "adminWithdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "chainID",
        type: "uint8",
      },
      {
        internalType: "uint64",
        name: "depositNonce",
        type: "uint64",
      },
      {
        internalType: "bytes32",
        name: "dataHash",
        type: "bytes32",
      },
    ],
    name: "cancelProposal",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "faucet",
    outputs: [
      {
        internalType: "contract BridgeFaucet",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "originChainID",
        type: "uint8",
      },
      {
        internalType: "uint64",
        name: "depositNonce",
        type: "uint64",
      },
      {
        internalType: "bytes32",
        name: "dataHash",
        type: "bytes32",
      },
    ],
    name: "getProposal",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "_resourceID",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "_dataHash",
            type: "bytes32",
          },
          {
            internalType: "address[]",
            name: "_yesVotes",
            type: "address[]",
          },
          {
            internalType: "address[]",
            name: "_noVotes",
            type: "address[]",
          },
          {
            internalType: "enum Bridge.ProposalStatus",
            name: "_status",
            type: "uint8",
          },
          {
            internalType: "uint256",
            name: "_proposedBlock",
            type: "uint256",
          },
        ],
        internalType: "struct Bridge.Proposal",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "relayer",
        type: "address",
      },
    ],
    name: "isRelayer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    name: "isTrustedForwarder",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newAdmin",
        type: "address",
      },
    ],
    name: "renounceAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "tollBooth",
    outputs: [
      {
        internalType: "contract BridgeTollBooth",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "address payable[]",
        name: "addrs",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
    ],
    name: "transferFunds",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "chainID",
        type: "uint8",
      },
      {
        internalType: "uint64",
        name: "depositNonce",
        type: "uint64",
      },
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "dataHash",
        type: "bytes32",
      },
    ],
    name: "voteProposal",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_tollBooth",
        type: "address",
      },
    ],
    name: "adminSetTollBooth",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address payable",
        name: "_faucet",
        type: "address",
      },
    ],
    name: "adminSetFaucet",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "destinationChainID",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "deposit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "chainID",
        type: "uint8",
      },
      {
        internalType: "uint64",
        name: "depositNonce",
        type: "uint64",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
    ],
    name: "executeProposal",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "createDataHash",
    outputs: [
      {
        internalType: "bytes32",
        name: "dataHash",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
];

const _bytecode =
  "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";

export class PalmBridge__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    chainID: BigNumberish,
    initialRelayers: string[],
    initialRelayerThreshold: BigNumberish,
    expiry: BigNumberish,
    forwarder: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<PalmBridge> {
    return super.deploy(
      chainID,
      initialRelayers,
      initialRelayerThreshold,
      expiry,
      forwarder,
      overrides || {}
    ) as Promise<PalmBridge>;
  }
  getDeployTransaction(
    chainID: BigNumberish,
    initialRelayers: string[],
    initialRelayerThreshold: BigNumberish,
    expiry: BigNumberish,
    forwarder: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      chainID,
      initialRelayers,
      initialRelayerThreshold,
      expiry,
      forwarder,
      overrides || {}
    );
  }
  attach(address: string): PalmBridge {
    return super.attach(address) as PalmBridge;
  }
  connect(signer: Signer): PalmBridge__factory {
    return super.connect(signer) as PalmBridge__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): PalmBridgeInterface {
    return new utils.Interface(_abi) as PalmBridgeInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): PalmBridge {
    return new Contract(address, _abi, signerOrProvider) as PalmBridge;
  }
}
